// 15074726674811
document.addEventListener('DOMContentLoaded', async function () {
  checkCartChocolateProduct();
  if(window.location.pathname == '/cart' || window.location.pathname == '/en/cart'){
    checkInvoiceBtnTerm();
  }
  if(window.location.pathname == '/pages/custom-invoice-form'){
    const response = await fetch('/cart.js');
    const cartItem = await response.json();

    const hasProduct1 = cartItem.items.some(item => item.product_id === 15082114482555);
    const hasProduct2 = cartItem.items.some(item => item.product_id === 15074726674811);

    if (hasProduct1 || hasProduct2) {
      // console.log("YEs");
    }else {
       window.location.href = '/';
    }
  }
});



async function checkCartChocolateProduct() {
  const checkoutBtn = document.querySelector('.cart__checkout');
  const invoiceBtn = document.querySelector('.pay_invoice_btn');
  console.log(12);
  if (!checkoutBtn) return;

  const labelDefault = checkoutBtn.querySelector('.label-default');
  const labelInvoice = checkoutBtn.querySelector('.label-invoice');

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

   // const onlyPave = cart.items.every(item => item.product_id === 15082114482555);
    const hasProduct1 = cart.items.some(item => item.product_id === 15082114482555);
    const hasProduct2 = cart.items.some(item => item.product_id === 15074726674811);
      console.log("here")
   if ((hasProduct1 || hasProduct2) && cart.items.length > 0) {
      labelDefault.style.display = 'none';
      labelInvoice.style.display = 'inline';
      invoiceBtn.style.display = 'block';
    } else {
      labelDefault.style.display = 'inline';
      labelInvoice.style.display = 'none';
      invoiceBtn.style.display = 'none';
    }

  } catch (err) {
    console.error('Error loading cart:', err);
  }
}



// term checkbox checked or not
function checkInvoiceBtnTerm() {
  const payInvoiceBtn = document.querySelector('.pay_invoice_btn');
  const termsCheckbox = document.querySelector('.rterms-checkbox');
  if (payInvoiceBtn) {
    // Remove any existing click listeners to avoid duplicates (optional)
    payInvoiceBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Re-query inside the click to ensure it's latest
      const currentTermsCheckbox = document.querySelector('.rterms-checkbox');

      if (!currentTermsCheckbox || !currentTermsCheckbox.checked) {
        // alert('Please accept the terms and conditions before completing your order');
        const alertMessage = window.rterms?.metafield?.alert_message || "Please accept the terms and conditions before completing your order";
        alert(alertMessage);
      } else {
        window.location.href = '/pages/custom-invoice-form';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  const deliveryDateField = document.querySelector('.delivery-date-field');

  if (deliveryDateField) {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      const productIdToHideField = 15074726674811;

      // Check if ALL items in cart are the specific product
      const allItemsAreSpecificProduct = cart.items.every(item => item.product_id === productIdToHideField);

      if (!allItemsAreSpecificProduct) {
        // Show the delivery date field in all other cases
        deliveryDateField.style.display = 'block';
      }
      // If all items in the cart are the specific product, we keep the field hidden (default display: none)

    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }
});





